import { Loader2 } from "lucide-react";

const PageLoadingFallback = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-amber-500/20 animate-ping" />
          <Loader2 className="h-12 w-12 text-amber-600 dark:text-amber-400 animate-spin relative z-10" />
        </div>
        <p className="text-slate-600 dark:text-slate-300 font-medium animate-pulse">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default PageLoadingFallback;
